// src/styles/colors.js
export const colors = {
  flagship: "#004D40", // Deep teal, your brand color
  primary: "#00A36C", // Vibrant green accent
  secondary: "#FFD700", // Original gold for highlights
  gold: "#D4AF37", // Real gold color, rich and metallic
  background: "#F5F5F5", // Light grey background
  surface: "#FFFFFF", // White for cards
  textDark: "#1A1A1A", // Deeper black for contrast
  textLight: "#666666", // Softer grey for secondary text
  accent: "#FF6F61", // Coral for buttons or alerts
  gradientStart: "#004D40", // Gradient start (deep teal)
  gradientEnd: "#00A36C", // Gradient end (vibrant green)
  darkBane: "#333", // Dark gray for inactive states
  error: "#FF3B30", // Red for destructive actions
  border: "#E0E0E0", // Light gray for borders
};